import { handleActions } from "redux-actions";

import { removeById, updateById } from "utils";

const tenantContactReducer = handleActions(
  {
    TENANT_CONTACTS_GET: {
      FULFILLED: (state, action) => ({
        tenantContacts: action.payload.tenantContacts,
      }),
    },
    TENANT_CONTACT_SAVE: {
      FULFILLED: (state, action) => ({
        tenantContacts: updateById(state.tenantContacts, action.payload.tenantContact),
      }),
    },
    TENANT_CONTACT_DELETE: {
      FULFILLED: (state, action) => ({
        tenantContacts: removeById(state.tenantContacts, action.meta.tenantContactID),
      }),
    },
    TENANT_CONTACT_CREATE: {
      FULFILLED: (state, action) => ({
        tenantContacts: [...state.tenantContacts, action.payload.tenantContact],
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default tenantContactReducer;
